import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';




import { LoginComponent } from './login/login.component';
import { ForgotpswComponent } from './forgotpsw/forgotpsw.component';
import { FiledetailsComponent } from './filedetails/filedetails.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ViewFileComponent } from './view-file/view-file.component';
import { ConsoleReportComponent } from './console-report/console-report.component';
import { UserListComponent } from './user-list/user-list.component';
import { AddCompanyComponent } from './add-company/add-company.component';
import { AddUserComponent } from './add-user/add-user.component';
import { ListCompanyComponent } from './list-company/list-company.component';
import { PendreqComponent } from './pendreq/pendreq.component';
import { FileauditComponent } from './fileaudit/fileaudit.component';
import { FileauditdetailsComponent } from './fileauditdetails/fileauditdetails.component';
import { AnalystDashComponent } from './analyst-dash/analyst-dash.component';
import { AdminDashComponent } from './admin-dash/admin-dash.component';
import { CeoDashComponent } from './ceo-dash/ceo-dash.component';
import { HelpDocComponent } from './help-doc/help-doc.component';
import { AdminfileComponent } from './adminfile/adminfile.component';
import { AdminFileViewComponent } from './admin-file-view/admin-file-view.component';
import { DataLockConfigComponent } from './data-lock-config/data-lock-config.component';
import { LoginAuditComponent } from './login-audit/login-audit.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { UserAuditComponent } from './user-audit/user-audit.component';
import { ConsoleViewComponent } from './console-view/console-view.component';
import { ChangePswComponent } from './change-psw/change-psw.component';
import { CompanyAuditComponent } from './company-audit/company-audit.component';
import { DelReqComponent } from './del-req/del-req.component';
import { QueryReportComponent } from './query-report/query-report.component';
import { QreportViewComponent } from './qreport-view/qreport-view.component';
import { PenreqAuditComponent } from './penreq-audit/penreq-audit.component';
import { UnlockSettingsComponent } from './unlock-settings/unlock-settings.component';
import { UnformatUploadComponent } from './unformat-upload/unformat-upload.component';
import { UnformatListComponent } from './unformat-list/unformat-list.component';
import { UnformatAuditComponent } from './unformat-audit/unformat-audit.component';
import { AdminConsoleComponent } from './admin-console/admin-console.component';
import { AdminConsoleViewComponent } from './admin-console-view/admin-console-view.component';
import { AdminQreportComponent } from './admin-qreport/admin-qreport.component';
import { AdminQrviewComponent } from './admin-qrview/admin-qrview.component';
import { EmailConfigComponent } from './email-config/email-config.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdminPdApproveComponent } from './admin-pd-approve/admin-pd-approve.component';
import { AnalystHelpComponent } from './analyst-help/analyst-help.component';
import { FlashUploadComponent } from './flash-upload/flash-upload.component';
import { FlashViewComponent } from './flash-view/flash-view.component';
import { FlashReportComponent } from './flash-report/flash-report.component';
import { FlashReportViewComponent } from './flash-report-view/flash-report-view.component';
import { FileMatrixComponent } from './file-matrix/file-matrix.component';
import { ComplianceComponent } from './compliance/compliance.component';
import { LandingPageComponent } from './landing-page/landing-page.component';



import { AnalystComponent } from './analyst/analyst.component';
import { AdminComponent } from './admin/admin.component';
import { CeoComponent } from './ceo/ceo.component';
//import { Compliance } from './compliance/compliance.component';

import { AuthService } from './auth.service';
import { AdminAuthService } from './admin-auth.service';
import { CeoAuthService } from './ceo-auth.service';

const routes: Routes = [
	{
		path:"",
		component:LoginComponent
	},
	{
		path:"forgotpassword",
		component:ForgotpswComponent
	},
	{
		path:"analyst",
		component:AnalystComponent,
		canActivate: [AuthService],
        canActivateChild: [AuthService],
        children: [
        	{
        		path: 'fileupload',
            	component: FileUploadComponent
            },
            {
                path: 'flashUpload',
                component: FlashUploadComponent
            },
            {
                path: 'flashView',
                component: FlashViewComponent
            },
            {
                path: 'flashReport',
                component: FlashReportComponent

            },
            {
                path: 'flashReportView/:month/:year',
                component: FlashReportViewComponent

            },
            {
        		path: 'viewfile',
            	component: ViewFileComponent
            },
            {
        		path: 'consoleReport',
            	component: ConsoleReportComponent
            },
            {
            	path: 'filedetails/:id',
            	component: FiledetailsComponent

            },
            {
                path: 'filedetails/:id/:sheetIndex',
                component: FiledetailsComponent

            },
            {
                path: 'dashboard',
                component: AnalystDashComponent

            },
            {
                path: 'consoleview/:type/:sheetIndex/:fileName',
                component: ConsoleViewComponent

            },
            {
                path: 'changepassword',
                component: ChangePswComponent

            },
            {
                path: 'delrequest',
                component: DelReqComponent

            },
            {
                path: 'queryreport',
                component: QueryReportComponent

            },
            {
                path: 'qreportview/:id',
                component: QreportViewComponent

            },
            {
                path: 'otherfileupload',
                component: UnformatUploadComponent

            },
            {
                path: 'otherfilelist',
                component: UnformatListComponent

            },
            {
                path: 'helpdoc',
                component: AnalystHelpComponent

            },
            {
                path: 'landingpage',
                component: LandingPageComponent

            }
        ]
	},
	{
		path:"admin",
		component:AdminComponent,
		canActivate: [AdminAuthService],
        canActivateChild: [AdminAuthService],
        children: [
        	{
        		path: 'userlist',
            	component: UserListComponent
            },
            {
                path: 'adduser',
                component: AddUserComponent
            },
            {
        		path: 'addcompany',
            	component: AddCompanyComponent
            },
            {
                path: 'listcompany',
                component: ListCompanyComponent
            },
            {
                path: 'pendingreq',
                component: PendreqComponent
            },
            {
                path: 'pendingreqaudit',
                component: PenreqAuditComponent
            },
            {
                path: 'fileaudit',
                component: FileauditComponent
            },
            {
                path: 'fileauditdetails',
                component: FileauditdetailsComponent

            },
            {
                path: 'dashboard',
                component: AdminDashComponent

            },
            {
                path: 'helpdoc',
                component: HelpDocComponent

            },
            {
                path: 'filelist',
                component: AdminfileComponent

            },
            {
                path: 'fileview/:id',
                component: AdminFileViewComponent

            },
            {
                path: 'fileview/:id/:sheetIndex',
                component: AdminFileViewComponent

            },
            {
                path: 'fileview/:id/:sheetIndex/:pageDetails',
                component: AdminFileViewComponent

            },
            {
                path: 'datalockconfig',
                component: DataLockConfigComponent

            },
            {
                path: 'loginaudit',
                component: LoginAuditComponent

            },
            {
                path: 'edituser/:id',
                component: EditUserComponent

            },
            {
                path: 'useraudit',
                component: UserAuditComponent

            },
            {
                path: 'useraudit/:id',
                component: UserAuditComponent

            },
            {
                path: 'changepassword',
                component: ChangePswComponent

            },
            {
                path: 'companyaudit',
                component: CompanyAuditComponent

            },
            {
                path: 'unlocksettings',
                component: UnlockSettingsComponent

            },
            {
                path: 'otherfileaudit',
                component: UnformatAuditComponent

            },
            {
                path: 'consolereport',
                component: AdminConsoleComponent

            },
            {
                path: 'consoleview/:type/:sheetIndex/:fileName',
                component: AdminConsoleViewComponent

            },
            {
                path: 'queryreport',
                component: AdminQreportComponent

            },
            {
                path: 'qreportview/:id',
                component: AdminQrviewComponent

            },
            {
                path: 'emailconfig',
                component: EmailConfigComponent

            },
            {
                path: 'pdapprove',
                component: AdminPdApproveComponent

            },
            {
                path: 'flashUpload',
                component: FlashUploadComponent
            },
            {
                path: 'flashView',
                component: FlashViewComponent
            },
            {
                path: 'flashReport',
                component: FlashReportComponent

            },
            {
                path: 'flashReportView/:month/:year',
                component: FlashReportViewComponent

            },
            {
                path: 'fileMatrix',
                component: FileMatrixComponent

            },
            {
                path: 'landingpage',
                component: LandingPageComponent

            }
        ]
	},
    {
        path:"ceo",
        component:CeoComponent,
        canActivate: [CeoAuthService],
        canActivateChild: [CeoAuthService],
        children: [
            {
                path: 'dashboard',
                component: CeoDashComponent

            },
        ]
    },
    {
        path:"compliance",
        component:ComplianceComponent,
        //canActivate: [ComplianceAuthService],
        //canActivateChild: [ComplianceAuthService],
        children: [
            {
                path: 'consolereports',
                component: ConsoleReportComponent

            },
            {
                path: 'flashReport',
                component: FlashReportComponent
            },
            {
                path: 'consoleview/:type/:sheetIndex/:fileName',
                component: ConsoleViewComponent

            },
            {
                path: 'flashReportView/:month/:year',
                component: FlashReportViewComponent

            },
        ]
    },
    {
        path:"dashboard",
        component:DashboardComponent,
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
